import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import { DashboardLayout } from '@/layouts/marketplace';
import { routes } from './paths';
import { LazyPage } from './lazy-page';

const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      {
        path: '/',
        element: LazyPage(() => import('@/pages/flights/home')),
      },
      {
        path: routes.fights.saved,
        element: LazyPage(() => import('@/pages/flights/saved')),
      },
      {
        path: routes.fights.account,
        element: LazyPage(() => import('@/pages/flights/account')),
      },
      {
        path: routes.fights.deals,
        element: LazyPage(() => import('@/pages/flights/deals')),
      },
      {
        path: routes.fights.guides.root,
        element: LazyPage(() => import('@/pages/guides')),
      },
      {
        path: routes.fights.guides.athens,
        element: LazyPage(() => import('@/pages/guides/athens')),
      },
      {
        path: '*',
        element: LazyPage(() => import('@/pages/errors/not-found')),
      }
    ],
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
